module.exports = __webpack_public_path__ + "static/img/sapidoLOGOw.944c3bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sapidoLOGOw.png
// module id = PSee
// module chunks = 1